import { render } from "./HomeEventos.vue?vue&type=template&id=778e8389"
import script from "./HomeEventos.vue?vue&type=script&lang=js"
export * from "./HomeEventos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__